"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pshowPair = void 0;
var uint8array_utils_1 = require("@harmoniclabs/uint8array-utils");
var clearAsData_1 = require("../../type_system/tyArgs/clearAsData.js");
var getDirectFstT_1 = require("../../type_system/tyArgs/getDirectFstT.js");
var getDirectSndT_1 = require("../../type_system/tyArgs/getDirectSndT.js");
var types_1 = require("../../type_system/types.js");
var builtins_1 = require("../builtins/index.js");
var pfn_1 = require("../pfn.js");
var phoist_1 = require("../phoist.js");
var std_1 = require("../std/index.js");
var pshow_1 = require("./pshow.js");
function pshowPair(t) {
    var fstT = (0, clearAsData_1.clearAsData)((0, getDirectFstT_1.getDirectFstT)(t));
    var sndT = (0, clearAsData_1.clearAsData)((0, getDirectSndT_1.getDirectSndT)(t));
    var pfst = (0, builtins_1.pfstPair)(fstT, sndT);
    var psnd = (0, builtins_1.psndPair)(fstT, sndT);
    return (0, phoist_1.phoist)((0, pfn_1.pfn)([
        (0, types_1.lam)(fstT, types_1.bs),
        (0, types_1.lam)(sndT, types_1.bs),
        t
    ], types_1.bs)(function (showFst, showSnd, p) {
        return (0, std_1.pByteString)((0, uint8array_utils_1.fromAscii)("( "))
            .concat(showFst.$(pfst.$(p)))
            .concat((0, uint8array_utils_1.fromAscii)(", "))
            .concat(showSnd.$(psnd.$(p)))
            .concat((0, uint8array_utils_1.fromAscii)(" )"));
    }))
        .$((0, pshow_1.pshow)(fstT))
        .$((0, pshow_1.pshow)(sndT));
}
exports.pshowPair = pshowPair;
